/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CollaborateurApercuDto } from './CollaborateurApercuDto';
import {
    CollaborateurApercuDtoFromJSON,
    CollaborateurApercuDtoFromJSONTyped,
    CollaborateurApercuDtoToJSON,
    CollaborateurApercuDtoToJSONTyped,
} from './CollaborateurApercuDto';

/**
 * 
 * @export
 * @interface CabinetBriquesPlateformeDto
 */
export interface CabinetBriquesPlateformeDto {
    /**
     * 
     * @type {string}
     * @memberof CabinetBriquesPlateformeDto
     */
    personneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof CabinetBriquesPlateformeDto
     */
    designation: string;
    /**
     * 
     * @type {string}
     * @memberof CabinetBriquesPlateformeDto
     */
    nature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CabinetBriquesPlateformeDto
     */
    natureLibelle?: string | null;
    /**
     * La PM principale (titulaire) de la plateforme — badge d'affichage.
     * @type {boolean}
     * @memberof CabinetBriquesPlateformeDto
     */
    isPlateformeOwner: boolean;
    /**
     * 
     * @type {number}
     * @memberof CabinetBriquesPlateformeDto
     */
    collaborateursActifs: number;
    /**
     * Aperçu des collaborateurs pour la pile d'avatars (principal en tête, capé à 4 — membresActifs porte le total).
     * 
     * @type {Array<CollaborateurApercuDto>}
     * @memberof CabinetBriquesPlateformeDto
     */
    collaborateurs?: Array<CollaborateurApercuDto>;
}

/**
 * Check if a given object implements the CabinetBriquesPlateformeDto interface.
 */
export function instanceOfCabinetBriquesPlateformeDto(value: object): value is CabinetBriquesPlateformeDto {
    if (!('personneMoraleId' in value) || value['personneMoraleId'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('isPlateformeOwner' in value) || value['isPlateformeOwner'] === undefined) return false;
    if (!('collaborateursActifs' in value) || value['collaborateursActifs'] === undefined) return false;
    return true;
}

export function CabinetBriquesPlateformeDtoFromJSON(json: any): CabinetBriquesPlateformeDto {
    return CabinetBriquesPlateformeDtoFromJSONTyped(json, false);
}

export function CabinetBriquesPlateformeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinetBriquesPlateformeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'personneMoraleId': json['personneMoraleId'],
        'designation': json['designation'],
        'nature': json['nature'] == null ? undefined : json['nature'],
        'natureLibelle': json['natureLibelle'] == null ? undefined : json['natureLibelle'],
        'isPlateformeOwner': json['isPlateformeOwner'],
        'collaborateursActifs': json['collaborateursActifs'],
        'collaborateurs': json['collaborateurs'] == null ? undefined : ((json['collaborateurs'] as Array<any>).map(CollaborateurApercuDtoFromJSON)),
    };
}

export function CabinetBriquesPlateformeDtoToJSON(json: any): CabinetBriquesPlateformeDto {
    return CabinetBriquesPlateformeDtoToJSONTyped(json, false);
}

export function CabinetBriquesPlateformeDtoToJSONTyped(value?: CabinetBriquesPlateformeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personneMoraleId': value['personneMoraleId'],
        'designation': value['designation'],
        'nature': value['nature'],
        'natureLibelle': value['natureLibelle'],
        'isPlateformeOwner': value['isPlateformeOwner'],
        'collaborateursActifs': value['collaborateursActifs'],
        'collaborateurs': value['collaborateurs'] == null ? undefined : ((value['collaborateurs'] as Array<any>).map(CollaborateurApercuDtoToJSON)),
    };
}

